module.exports = __webpack_public_path__ + "static/brightgiraffecomforter-feea1b46ec3256a0e1e2fafe639f4411.jpeg";